<template>
  <v-app :style="cssVariables" v-bind:class="{ 'hide-menu': setHideMenuClass }">
    <loading full v-if="isShowLoading" />

    <transition name="fade" mode="out-in" appear>
      <router-view/>
    </transition>

    <v-snackbar :timeout="snackbar.timeout" :color="snackbar.color" :multi-line="snackbar.multiline" :vertical="snackbar.vertical"
      :top="snackbar.top" :bottom="snackbar.bottom" :left="snackbar.left" :right="snackbar.right" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn flat @click.native="snackbar.show = false">Fechar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Loading from '@/components/ui/Loading'

export default {
  components: { Loading },
  computed: {
    setHideMenuClass () {
      return window.innerWidth < 1264
      // the screen value 1264 is equal mobile-break-point default of navigation-drawers component. To read more api documentation
    },
    cssVariables () {
      return {
        '--primary': this.$vuetify.theme.primary,
        '--secondary': this.$vuetify.theme.secondary,
        '--accent': this.$vuetify.theme.accent,
        '--action': this.$vuetify.theme.action,
        '--error': this.$vuetify.theme.error,
        '--info': this.$vuetify.theme.info,
        '--success': this.$vuetify.theme.success,
        '--warning': this.$vuetify.theme.warning
      }
    }
  },
  data () {
    return {
      isShowLoading: false,
      snackbar: {
        show: false,
        color: 'success',
        text: '',
        timeout: 8000,
        vertical: false,
        multiline: false,
        top: true,
        left: false,
        bottom: false,
        right: false
      }
    }
  },
  methods: {
    addListenerSnackbar () {
      this.$root.$on('snackbar', data => {
        this.$nextTick(() => {
          this.snackbar = { ...this.snackbar, ...data }
        })
      })
    },
    addListenerLoading () {
      this.$root.$on('loading', data => {
        this.isShowLoading = data
      })
    }
  },
  mounted () {
    this.addListenerSnackbar()
    this.addListenerLoading()
  }
}
</script>
